import React, { Component } from "react";
import PropTypes from "prop-types";
import { MenuItem, Select } from "@mui/material";
import { LenghtUnit, MassUnit } from "../../models/features/Product/Product";

interface LenghtUnitListProps {
  onChange: any;
  value: any;
  name?: string;
  id?: string;
}

const LenghtUnitList: React.FunctionComponent<LenghtUnitListProps> = ({
  onChange,
  value,
  id,
  name,
}) => {
  return (
    <Select
      name={name ?? ""}
      id={id ?? ""}
      value={
        value == "Foot"
          ? 0
          : value == "Inch"
          ? 1
          : value == "Meter"
          ? 2
          : value == "Yard"
          ? 3
          : value == "Mile"
          ? 4
          : value
      }
      onChange={onChange}
      defaultValue={2}
      variant={"standard"}
    >
      {/* <MenuItem value="">
        <em>None</em>
      </MenuItem> */}
      {LenghtUnit.map((item) => (
        <MenuItem value={item.value}>{item.title}</MenuItem>
      ))}
    </Select>
  );
};

export default LenghtUnitList;
